import { AxiosError } from "axios";
import { toast } from "react-toastify";
import {ErrorGrantModel, ErrorModel} from "../models/error.model";

export class ErrorHelper {

  public static isGrantError(errorModelOrError: ErrorGrantModel | Error | unknown): errorModelOrError is ErrorGrantModel {
    return (errorModelOrError as ErrorGrantModel).error_description !== undefined;
  }
  
  public static isErrorModel(errorModelOrError: ErrorModel | Error | unknown): errorModelOrError is ErrorModel {
    return (errorModelOrError as ErrorModel).reason !== undefined;
  }

  public static isError(errorModelOrError: ErrorModel | Error | unknown): errorModelOrError is Error {
    return (errorModelOrError as Error).message !== undefined;
  }

  public static showInternalErrors(ex: ErrorModel | Error | unknown) {
    if (!ErrorHelper.isErrorModel(ex)) {
      if (ErrorHelper.isError(ex)) {
        toast.error(ex.message);
        return;
      }
      
      if(ErrorHelper.isGrantError(ex))
      {
        toast.error(ex.error_description);
        return;
      }
      
      toast.error("Unknown error occurred.");
      return;
    }

    const messages = ex.messages;

    if (messages.length === 1) {
      toast.error(messages[0]);
      return;
    }

    if (messages.length > 1) {
      toast.error(() => <ul>{messages.map((message, i) => <li key={i}>{message}</li>)}</ul>);
      return;
    }

    toast.error("An error occurred.");
  }
  
  public static showErrors(ex: AxiosError) {
    ex.response?.data ? this.showInternalErrors(ex.response.data) : toast.error("An error occurred.");
  }
}
